export function timerWorker() {
  let _timer;
  self.onmessage = function (ev) {
    const data = ev.data;
    // const timer = Symbol();

    switch (data.cmd) {
      case 'start': {
        _timer = setInterval(function () {
          postMessage(Date.now());
        }, data.interval);
        break;
      }
      case 'stop': {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        _timer && clearInterval(_timer);
        break;
      }
      default: {
        throw new Error('Invalid cmd: ' + data.cmd);
      }
    }
  };
}
